import React, {useState} from 'react';
import {Avatar, Button, Container, Paper, Typography,} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import useUser from "../auth/useUser";
import {getAuthClient} from '../auth/auth';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from '@mui/material/Checkbox';

export interface ILoginElementProps {
  type: 'login' | 'register' | 'password_reset',
  onLogin: Function,
  header?: {
    labelLogin?: string,
    labelRegister?: string,
    labelPasswordReset?: string,
    className?: string,
  },
  button?: {
    fullWidth?: boolean
  }


}


const LoginElement = (props: ILoginElementProps) => {
  const [user, userActions] = useUser();

  const [type, setType] = useState<string>(props.type);
  const [name, setName] = useState<string>('');
  const [pass, setPass] = useState<string>('');
  const [showPassword, setShowPassword] = React.useState(false);

  const [submitting, setSubmitting] = useState<boolean>(false);


  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);

    if (type == 'login') {
      userActions.login(name, pass)
        .then(() => {
          props.onLogin();
          setSubmitting(false);
        })
        .catch((error) => {
          setSubmitting(false);
        });
    }
    if (type=='register') {
      userActions.register(name, pass)
        .then(() => {
          props.onLogin();
          setSubmitting(false);
        })
        .catch((error) => {
          setSubmitting(false);
        });
    }

  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Box className={props.header?.className ?? 'text-5xl font-bold pb-6 text-center'}>
        {type == 'login' && (props.header?.labelLogin ?? 'Anmelden')}
        {type == 'register' && (props.header?.labelRegister ?? 'Neues Benutzerkonto')}
        {type == 'password_reset' && (props.header?.labelPasswordReset ?? 'Passwort zurücksetzen')}
      </Box>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
        <TextField
          label="E-Mail"
          fullWidth
          required
          autoFocus
          sx={{mb: 2}}
          value={name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setName(event.target.value);
          }}
        />
        {/*<TextField*/}
        {/*  label="Passwort"*/}
        {/*  fullWidth*/}
        {/*  required*/}
        <FormControl sx={{}} variant="outlined" fullWidth>
          <InputLabel
            htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            value={pass}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPass(event.target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff/> : <Visibility/>}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        {type == 'login' &&
          <Box sx={{textAlign: "right", marginTop: 0}}>
            <a onClick={() => {
              setType('password_reset')
            }}>Passwort zurücksetzen</a>
          </Box>
        }
        {type == 'register' &&
          <FormControlLabel required control={<Checkbox />} label="Ich stimme den AGB und Datenschutzhinweisen zu." />
        }
        <Button type="submit" variant="contained" disabled={submitting}
                fullWidth={props.button?.fullWidth ?? true} sx={{marginTop: 4}}>
          {type == 'login' && 'Anmelden'}
          {type == 'register' && 'Benutzerkonto erstellen'}
          {type == 'password_reset' && 'Passwort zurücksetzen'}
        </Button>
        <Box sx={{textAlign: "left", marginTop: 2}}>
          {type == 'login' &&
            <a onClick={() => {
              setType('register')
            }}>Sie haben noch kein Benutzerkonto? Zur Registrierung</a>
          }
          {(type == 'register' || type == 'password_reset') &&
            <a onClick={() => {
              setType('login')
            }}>Zur Anmeldung</a>
          }
        </Box>
      </Box>
    </>
  );
};

export default LoginElement;
